module.exports = __webpack_public_path__ + "static/media/icon_clean.eadbf9cc.png";